import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { Checkbox } from "../../FormElement/Checkbox";
import { ModalConfirm } from "../../ModalConfirm";
import "./styles.scss";

interface AccountDeletionSectionProps {
  onDeleteAccount?: () => void;
  onShowConfirmModal?: () => void;
}

export const AccountDeletionSection: React.FC<AccountDeletionSectionProps> = ({
  onDeleteAccount,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`accountManagementPage.${key}`);
  const [showConfirmModal, setShowConfirmModal] = useState<boolean>(false);
  const [isConfirmChecked, setIsConfirmChecked] = useState<boolean>(false);

  const handleDeleteClick = () => {
    setShowConfirmModal(true);
  };

  const handleConfirm = () => {
    if (isConfirmChecked && onDeleteAccount) {
      onDeleteAccount();
      setShowConfirmModal(false);
    }
  };

  const handleClose = () => {
    setShowConfirmModal(false);
    setIsConfirmChecked(false);
  };

  return (
    <div className="white-border-panel account-deletion-module">
      <div className="account-deletion-section">
        <div className="deletion-title">{t("account_deletion")}</div>
        <div className="horizontal-container">
          <div className="deletion-description">
            {t("account_deletion_description")}
          </div>
          <div className="action-buttons">
            <button className="btn btn-red" onClick={handleDeleteClick}>
              {t("account_deletion")}
            </button>
          </div>
        </div>
      </div>
      {showConfirmModal && (
        <ModalConfirm
          title="delete_confirm"
          cancelLabel="cancel"
          confirmLabel="account_deletion_confirm"
          onClose={handleClose}
          onConfirm={handleConfirm}
          color="red"
          disableConfirm={!isConfirmChecked}
        >
          <div className="confirmation-checkbox">
            <Checkbox
              id="confirm-deletion"
              checked={isConfirmChecked}
              onChange={(checked) => setIsConfirmChecked(checked)}
              label={t("account_deletion_description")}
            />
          </div>
        </ModalConfirm>
      )}
    </div>
  );
};

export default AccountDeletionSection;
